import axios from "axios";
import { getChainName } from "./utilities";
import { getEnv } from "../env";

const endpoint = getEnv("REACT_APP_API_URL", "https://api.notarify.io");
const endpointBB = getEnv("REACT_APP_BLACKBOX_URL", "https://blackbox.notarify.io");

// Fail fast: backend explorer/block/getOne can hang ~30s on Mongo timeout when
// the block is unknown. Keep total probe time bounded so the UI doesn't freeze.
axios.defaults.timeout = 8000;

export async function getDocumentData(
  hash: string,
  lastVersion: boolean
): Promise<any> {
  try {
    const response = await axios.get(
      `${endpoint}/explorer/getBasicData/?documentHash=${hash}&lastVersion=${lastVersion}`
    );
    return response;
  } catch (err: any) {
    if (err.response) {
      return {
        status: err.response?.status,
        data: err.response?.data,
      };
    } else {
      return {
        status: 500,
        data: { status: "Internal server error", details: "Unknown error" },
      }; // Rethrow the error for other error scenarios// Rethrow the error for other error scenarios
    }
  }
}

export async function getBBData(
  hash: string
): Promise<any> {
  try {
    const response = await axios.get(
      `${endpointBB}/stamp/info/BBhash/${hash}`
    );
    return response;
  } catch (err: any) {
    if (err.response) {
      return {
        status: err.response?.status,
        data: err.response?.data,
      };
    } else {
      return {
        status: 500,
        data: { status: "Internal server error", details: "Unknown error" },
      }; // Rethrow the error for other error scenarios// Rethrow the error for other error scenarios
    }
  }
}

export async function getBlockHashData(
  blockHash: string,
  blockchain: string,
  docName: string,
  txId?: string
): Promise<any> {
  try {
    const params: {
      txId?: string;
      id?: string;
      blockHash?: string;
    } = {};
    if (txId) {
      try {
        const response = await axios.get(
          `${endpointBB}/stamp/verify/txId/?txId=${txId}`
        );
        if (response.status === 200) {
          return {
            status: 200,
            data: {
              block: {
                hash: response.data.transaction.rootHash,
                datetime: response.data.transaction.datetime,
                transaction: response.data.transaction.txId,
                documents: [],
                signatures: [],
                currDocument: null,
                blockchain: getChainName(response.data.transaction.name),
              },
            },
          };
        }
      } catch (error: any) {
        return {
          status: error?.response?.status ?? 404,
          data: error?.response?.data ?? {
            status: "Not Found",
            details: "Transaction not found",
          },
        };
      }
    }
    params.blockHash = blockHash;
    params.id = docName;
    const response = await axios.get(`explorer/block/getOne/`, {
      params,
      baseURL: endpoint,
    });

    return response;
  } catch (err: any) {
    if (err.response) {
      return {
        status: err.response?.status,
        data: err.response?.data,
      };
    } else {
      return {
        status: 500,
        data: { status: "Internal server error", details: "Unknown error" },
      }; // Rethrow the error for other error scenarios
    }
  }
}

export async function getBlockBBHashData(
  rootHash: string,
  leafHash?: string
): Promise<any> {
  try {
    const params = new URLSearchParams({ rootHash });
    if (leafHash) params.set("leafHash", leafHash);
    let response = await axios.get(
      `${endpointBB}/stamp/verify/hash/?${params.toString()}`
    );
    return response;
  } catch (err: any) {
    if (err.response) {
      return {
        status: err.response?.status,
        data: err.response?.data,
      };
    } else {
      return {
        status: 500,
        data: { status: "Internal server error", details: "Unknown error" },
      };
    }
  }
}

export async function getSignatureHashData(
  signatureHash: string
): Promise<any> {
  return axios.get(
    `${endpoint}/signature/getBasicData/?signatureHash=${signatureHash}`
  );
}
